import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const AnchorGrayscale = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17.5601 21.3733C19.9801 21.8033 23.0001 16.6433 23.0001 16.6433L17.2301 17.0233C16.4901 19.2233 16.3201 20.8533 17.5601 21.3733Z",
                fill: "url(#paint0_linear_8215_6954)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17.64 4.58338C17.1 3.78338 17.29 3.69338 16.3 3.54338C15.98 3.49338 15.78 2.34338 12.84 3.89338C8.9 5.97338 2.61 13.0834 1 15.2634L8.68 14.7534C10.42 12.6634 13.91 8.76338 15.96 7.71338C17.32 6.75338 18.35 5.63338 17.64 4.58338Z",
                fill: "url(#paint1_linear_8215_6954)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.5302 11.8834C19.6502 11.6234 19.7502 11.4234 19.8002 11.2934C20.8602 8.69338 22.0802 6.91338 20.4802 4.97338C19.3902 3.64338 16.4402 2.33338 13.9302 3.38338C14.9902 3.15338 15.8002 3.23338 16.3102 4.00338C17.2202 5.37338 15.3302 8.26338 14.6302 9.77338C13.8902 11.3734 13.0802 12.9534 12.5502 14.6434C12.1602 15.8634 11.8402 17.4334 12.7002 18.5334C13.4402 19.4934 15.5502 20.6334 16.1302 20.8934C16.6302 21.1134 17.1702 21.3534 17.7202 21.3934C15.4702 20.4834 18.0102 15.3634 19.5402 11.8834H19.5302Z",
                fill: "url(#paint2_linear_8215_6954)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_8215_6954",
                        x1: "13.7401",
                        y1: "20.4733",
                        x2: "26.1601",
                        y2: "16.5133",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.18",
                                stopColor: "#2B2B2B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.28",
                                stopColor: "#484848"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.37",
                                stopColor: "#626262"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.46",
                                stopColor: "#818181"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.54",
                                stopColor: "#888888"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.59",
                                stopColor: "#8B8B8B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_8215_6954",
                        x1: "17.96",
                        y1: "0.903383",
                        x2: "-5.4",
                        y2: "27.1534",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.04",
                                stopColor: "#4D4D4D",
                                stopOpacity: "0.9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.08",
                                stopColor: "#2F2F2F",
                                stopOpacity: "0.92"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.16",
                                stopColor: "#606060",
                                stopOpacity: "0.95"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.23",
                                stopColor: "#838383",
                                stopOpacity: "0.98"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.29",
                                stopColor: "#999999",
                                stopOpacity: "0.99"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.32",
                                stopColor: "#A2A2A2"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.43",
                                stopColor: "#ACACAC"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.56",
                                stopColor: "#D7D7D7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.63",
                                stopColor: "#EDECEC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_8215_6954",
                        x1: "-0.0198273",
                        y1: "19.9434",
                        x2: "27.8402",
                        y2: "6.65338",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.42",
                                stopColor: "#5D5D5D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.61",
                                stopColor: "#979797"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.77",
                                stopColor: "#929292"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.86",
                                stopColor: "#9C9C9C"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
